var React = require('react');

function Success (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"24","cy":"24","r":"24","fill":"#BFEFCD","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M34.8849 18.7641L21.8062 31.8429L13.8184 23.855L16.2182 21.4552L21.8062 27.0431L32.485 16.3643L34.8849 18.7641Z","fill":"#3DB460","key":1})]);
}

Success.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = Success;

Success.default = Success;
